import { Event } from "@mui/icons-material";
import { Card, CardMedia, Grid } from "@mui/material";
import { Dayjs } from "dayjs";
import React from "react";

import { AppointmentInfoRows } from "./AppointmentInfo";
import "./styles.scss";

export interface ITopCardMediaProps {
  startTime: Dayjs;
  endTime: Dayjs;
  location: string;
}

const TopCardMedia: React.FunctionComponent<ITopCardMediaProps> = ({
  startTime,
  endTime,
  location,
}) => {
  const time = `${startTime.format("h:mma")} - ${endTime.format("h:mma")}`;

  return (
    <CardMedia className="date">
      <Card className="schedule-card">
        <Grid container>
          <Grid item xs={2} className="calendar-icon">
            <Event sx={{ color: "secondary.contrastText" }} />
          </Grid>
          <Grid item xs={10} className="date-info">
            <Grid container spacing={0.5}>
              <Grid item>
                <h6 style={{ fontSize: 18 }}>
                  {startTime.format("dddd, MMM D")}
                </h6>
              </Grid>
              <Grid item>
                <AppointmentInfoRows
                  info={{ time, location }}
                  spacing={0.4}
                  color="secondary.contrastText"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </CardMedia>
  );
};

export default TopCardMedia;
